module.exports = __webpack_public_path__ + "static/media/carrier.1c365d7a.svg";